export default "/images/dc3be06ce57ee61c1b8a18dcf9ba6196.png";